﻿export class TypeContentEnum {
    static #_instance: TypeContentEnum

    public static get Instance() {
        this.#_instance ??= new TypeContentEnum();
        return this.#_instance;
    }

    public get Html() {
        return 1
    }

    public get Text() {
        return 0
    }

    public GetLibelle = (value: number) => {
        switch (value) {
            case 0:
                return "Text";
            case 1:
                return "Html";
        }
    }

    public GetByLibelle = (value: string) => {
        switch (value) {
            case "Text":
                return this.Text;
            case "Html":
                return this.Html;
            default:
                throw new Error("Type de contenu inconnu");
        }
    }

    public get GetListeLibelle() {
        return [
            {
                value: 0,
                text: "Text"
            },
            {
                value: 1,
                text: "Html"
            }
        ]
    }
}
